module.exports = function (fox) {
	var FormElementInput = require('./input')(fox);

	return fox.extend({}, FormElementInput, null, 'FormElementDomTextarea');
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/newForm/elements/dom/textarea.js
// module id = 95
// module chunks = 0